<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col xl="10">
          <v-row>
            <v-col>
              <v-img
                max-height="200"
                max-width="200"
                aspect-ratio="1"
                contain
                src="https://kuzee.x10spin.com/uploads/cache/resize/cede035f934852a1f914483b7eb8ed7b/58bd27c2d74cf.png"
              >
              </v-img>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              v-if="!this.$vuetify.breakpoint.smAndDown"
              cols="auto"
              align-self="center"
            >
              <v-row>
                <v-col cols="auto">
                  <v-btn
                    @click="settingsDialog = true"
                    text
                    color="primary"
                    dark
                  >
                    Je profiel bewerken
                  </v-btn>
                </v-col>
                <v-col cols="auto" align-self="center">
                  <v-btn
                    @click="transactionsDialog = true"
                    text
                    color="primary"
                    dark
                  >
                    Transactiesoverzicht
                  </v-btn>
                </v-col>
                <v-col cols="auto" align-self="center">
                  <div class="text-center">
                    <v-menu offset-y open-on-hover>
                      <template v-slot:activator="{ on }">
                        <v-btn text color="primary" dark v-on="on">
                          Info
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in infoItems"
                          :key="index"
                          @click="navItemOnClick(index)"
                        >
                          <v-list-item-title>{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-col>
                <v-col cols="auto" align-self="center">
                  <v-btn @click="$emit('logout')" color="primary" icon>
                    <v-icon>mdi-logout</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-else cols="auto" align-self="center">
              <v-btn color="primary" icon @click="toggleMobileNav">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-fade-transition>
            <div v-if="this.$vuetify.breakpoint.smAndDown && showMobileNav">
              <v-btn block text color="primary" @click="settingsDialog = true"
                >Je profiel bijwerken</v-btn
              >
              <v-divider></v-divider>
              <v-btn
                block
                text
                color="primary"
                @click="transactionsDialog = true"
                >Transactieoverzicht</v-btn
              >
              <v-divider></v-divider>
              <v-btn block text color="primary" @click="navItemOnClick(0)"
                >Gebruikersvoorwaarden</v-btn
              >
              <v-divider></v-divider>
              <v-btn block text color="primary" @click="navItemOnClick(1)"
                >Privacy verklaring</v-btn
              >
              <v-divider></v-divider>
              <v-btn block text color="primary" @click="$emit('logout')"
                >Log uit
                <v-icon class="ml-2 lighten-5 " small>mdi-logout</v-icon>
              </v-btn>
              <v-divider></v-divider>
            </div>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-container>
    <div class="secondary" style="height: 4px"></div>
    <SettingsDialog v-model="settingsDialog"></SettingsDialog>
    <TransactionsDialog v-model="transactionsDialog"></TransactionsDialog>
    <ConditionsDialog
      v-model="conditionsDialog"
      :init_tab="conditionsDialogInitTab"
    ></ConditionsDialog>
  </div>
</template>

<script>
import SettingsDialog from "./components/SettingsDialog";
import TransactionsDialog from "./components/TransactionsDialog";
import ConditionsDialog from "@/components/views/ConditionsDialog";
export default {
  name: "AppBar",
  components: { ConditionsDialog, TransactionsDialog, SettingsDialog },
  data() {
    return {
      infoItems: [
        { title: "Gebruikers voorwaarden", action: "CONDITIONS" },
        { title: "Privacy verklaring", action: "PRIVACY" }
      ],
      actions: {
        privacy: "PRIVACY",
        conditions: "CONDITIONS"
      },
      settingsDialog: false,
      transactionsDialog: false,
      conditionsDialog: false,
      conditionsDialogInitTab: 0,
      showMobileNav: false
    };
  },
  methods: {
    navItemOnClick(tab) {
      this.conditionsDialogInitTab = tab;
      this.conditionsDialog = true;
    },
    toggleMobileNav() {
      this.showMobileNav = !this.showMobileNav;
    }
  }
};
</script>

<style scoped></style>
